// LICENSE : MIT
"use strict";

var _kuromojin = require("./kuromojin");

module.exports = _kuromojin.tokenize;
module.exports.tokenize = _kuromojin.tokenize;
module.exports.getTokenizer = _kuromojin.getTokenizer;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/kuromojin/lib/index.js
// module id = 40
// module chunks = 0